export enum LocalStorage {
  DesignV2 = 'design_v2',
  MyDesignLocalV1 = 'my_design_local_v1',
  DoNotShowApplyMyDesignDialog = 'pref_do_not_show_apply_my_design_dialog',
  DoNotShowDeleteMyDesignDialog = 'pref_do_not_show_delete_my_design_dialog'
}
